import { Routes, Route } from "react-router-dom";
import React, {  useState,useEffect } from "react";

// import { Helmet, HelmetProvider } from "react-helmet-async";
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";

import LayoutHeader from "./mainLayouts/Layout";
import Home from "./pages/home/index";
import About from "./pages/aboutUs/";
import HowTobuy from "./pages/howTobuy";
import HowToSell from "./pages/howTosale";
import Faq from "./pages/Faq";
import PrivateSales from "./pages/PrivateSales";

import News from "./pages/News";
// import Videos from "./pages/Videos";
import Login from "./pages/Login/";
import Contact from "./pages/Contact";
import NotFound from "./pages/NotFound";
import UpcommingAuctions from "./pages/upcommingAuction";
import ResultsAuction from "./pages/resultAuction/";
import Jewelry from "./pages/Jewelry/";
import Watches from "./pages/Watches/";

import Handbags from "./pages/Handbags/";
import useMediaQuery from "@mui/material/useMediaQuery";



import LayoutHeaderAuctions from "./view/auctionsRoom/header";

import AuctionsViewOnly from "./view/viewingOnly/auctions";

// import LayoutHeaderAuctions from "./view/auctionsRoom/header";
import AuctionsRoom from "./view/auctionsRoom/auctions/";
import Declarator from "./view/declarator/console/";
import Live from  "./pages/live";
import Profile from "./view/profile";


// import Live from "./view/declarator/jointRoom";
import MyFavorite from "./view/Account/myfavorite";
import Mylots from "./view/Account/mylots";
import Invoice from "./view/Account/invoice";
import Account from "./view/Account/profile";
 import Room from "./view/Account";

import LotView from "./pages/Lot";
import SearchLot from "./pages/SearchLot";

import PrivateSalesAndExhibition from "./pages/PrivateSell";

import SinglePageProduct from "./pages/SinglePageProduct";
import SinglePrivate from "./pages/SInglePrivateProduct";

import Exhibition from "./pages/Exhibtion";
import ExhibitionPage from "./pages/ExhibtionPage";

import LeonGalleryMain from "./pages/Location/main/index";
import LeonGalleryInternational from "./pages/Location/international/index";
import LeonGalleryLafuerza from "./pages/Location/lafuerza/index";
import LeonGalleryMaison from "./pages/Location/maison/index";

import BlogSingle from "./pages/Blog-single";
import Blog from "./pages/Blog";
import RequestEstimate from "./pages/requestEstimate";
import SignIn from "./pages/Signup/";
// import { getToken } from "../src/Model/User";
// import Blog from "./pages/Blog";
import PrivateRoutes from "./PrivateRoute";



function App({}) {
  ///useMediaQuery("(min-width:900px)");
  const phoneMatch = useMediaQuery("(min-width:900px)");
  const matches = { phoneMatch };


  const [loading, setLoading] = React.useState(true);
  useEffect(() => {
  
    var counter = 0;

    var timer = setInterval(function () {

      if (navigator.onLine) {
        setLoading(false)
      
    
      }else{
        setLoading(true);

        if(counter === 2 ){
          alert('No Internet Connection!..')
          setLoading(true);
          clearInterval(timer);
        }
       
        // clearInterval(timer);
      }
  
     
      counter++;
  
  }, navigator.onLine === true ? 1000:9000);

    // To see changes in the network state, use addEventListener
    window.addEventListener("offline", (e) => {
      // clearInterval(timer);
     return setLoading(true);
    });
    
    window.addEventListener("online", (e) => {
      clearInterval(timer);
     return setLoading(false);
   
        
    
    });
   
  }, [navigator.onLine,loading]);

  
  // console.log("token app: ", token);
  return (
    
    <>
         <Backdrop sx={{
          color: "#fff",
          background: '#f3f1eb',
          zIndex: (theme) => theme.zIndex.drawer + 999,
          display: loading === true ? "block" : "none",
        }}
        open={loading}
        // onClick={handleClose}
      >
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: 600,
          }}
        >
          <div
            style={{
              verticalAlign: " top",
              display: "inline-block",
              textAlign: "center",
              width: 120,
            }}
          >
               <img src="/static/media/dddd.f96bbcbee8c8c2f5e3ee.png" alt="Awesome Logo" title="Leon Gallery" />

            <CircularProgress size="30px"  sx={{color: "black"}} />
          </div>
        </div>
      </Backdrop>
 <div style={{ visibility: loading === true ? "hidden" : "visible" }}>
      <Routes>
   
        <Route element={<LayoutHeader elementFoorer={false} />} >
          <Route path="/home" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/howtobuy" element={<HowTobuy />} />
          <Route path="/howtosell" element={<HowToSell />} />
          <Route path="/Live" element={<Live />} />
          
          <Route path="/request" element={<RequestEstimate />} />
          {/* Auction */}
          <Route path="/auctions" element={<UpcommingAuctions />} />
          <Route path="/results" element={<ResultsAuction />} />
          {/* BUY NOW */}
          <Route path="/buy/handbags" element={<Handbags />} />
          <Route path="/buy/watches" element={<Watches />} />
          <Route path="/buy/jewelry" element={<Jewelry />} />
          {/* PRIVATE SALE */}
          <Route path="/buy/private-sale/jewelry" element={<Jewelry />} />
          {/* <Route path="/private_sales" element={<PrivateSales />} /> */}
          {/* <Route path="/blog" element={<Blog />} /> */}
          <Route path="/news" element={<News />} />
          {/* <Route path="/videos" element={<Videos />} /> */}
          <Route path="/contact" element={<Contact />} />
          {/* auction list <a className="hide" href={`/auction/${value.c_slug}/${value.id}`}> */}
          <Route path="/auctions/:slug?/:id?" element={<LotView />} />

          <Route path="/live" element={<Live />} />

          <Route path="/search/:searching?" element={<SearchLot />} />

          <Route path="/private/sale" element={<PrivateSalesAndExhibition />} />

          <Route path="/auctions/:slug?/:titles?/:id?/:lotNo?" element={<SinglePageProduct />} />

          <Route path="/private/:slug?/:group?/:titles?/:id" element={<SinglePrivate />} />
       
          <Route path="/private_sales" element={<PrivateSales />} />
          <Route path="/stories" element={<Blog />} />
          <Route path="/stories/:slug?" element={<BlogSingle />} />
  
          <Route path="/exhibition/:slug/:id" element={<Exhibition />} />
          <Route path="/exhibition" element={<ExhibitionPage />} />
          <Route path="/location/main" element={<LeonGalleryMain />} />
          <Route
            path="/location/international"
            element={<LeonGalleryInternational />}
          />
          <Route path="/location/lafuerza" element={<LeonGalleryLafuerza />} />
          <Route path="/location/maison" element={<LeonGalleryMaison />} />

          <Route path="/faq" element={<Faq />} />

          <Route path="/" element={<Home />} />
          <Route path="*" element={<NotFound />} />

        {/* <Route path="/room" element={<Room />} /> */}

        <Route path="/login" element={<Login />} />
        <Route path="/Signup" element={<SignIn />} />
        <Route path="/home" element={<Home mediadQuery={matches} />} />

        {/* <Route element={<PrivateRoutes mediadQuery={matches} />}> */}
        <Route path="/profile" element={<Profile />}  mediadQuery={matches}/> 
         
        <Route path="/declarator/room" element={<Declarator />} />
            <Route path="/room" element={<Room />} />
            <Route path="/account" element={<Account />} />
            <Route path="/myfavorite" element={<MyFavorite />} />
            <Route path="/mylots" element={<Mylots />} />
            
              {/* <Route path="/joint/room" element={<JointRoom />} /> */}
              <Route
                path="/auctions/room"
                element={<AuctionsRoom 
                mediadQuery={matches} />}
              />

              <Route
                path="/auctions/view/only"
                element={<AuctionsViewOnly 
                mediadQuery={matches} />}
                />
              </Route>

      </Routes>
      </div>
    </>

  );
}

export default App;
